import React from 'react'
import SvgIcon from '../../../components/design-system/Icon/SvgIcon'

interface Props {
  isBold: boolean
}

export const CloseIcon: React.FC<Props> = ({ isBold }) => {
  if (!isBold) {
    return <SvgIcon name="closeButton" />
  }

  return <SvgIcon name="closeButtonBold" />
}
